export class MMBBaseEventParamsDto {
  micrositio: string;
  page_path: string;
  page_type: string;
  homemarket: string;
  environment: string;
  login: boolean;
  negocio: string;
  bundle?: string;
  buy_instance?: string;
  initial_date?: string;
  end_date?: string;
  exchange_rate?: string;
  from_iata?: string;
  to_iata?: string;
  full_trip?: string;
  full_trip_dates?: string;
  fare_basis?: string;
  count_seats?: number;
  count_bags?: number;
  count_carry_on?: number;
  passengers_adult?: number;
  passengers_child?: number;
  passengers_infant?: number;
  passengers_pet?: number;
  pax?: number;
  trip_type?: string;
  tag_price?: string;
  time?: string;
  currency?: string;
  payment_method?: string;
  pnr?: string;
  method?: string;
  ecommerce?: {
    transaction_id?: string;
    affiliation?: string;
    pnr?: string;
    payment_type?: string;
    tax?: number;
    value?: number;
    items?: Array<{
      active?: boolean;
      cabin?: string;
      date?: string;
      price?: number;
      priceWithTaxes?: number;
      index?: number;
      item_category?: string;
      item_id?: string;
      item_list_name?: string;
      item_name?: string;
      item_variant?: string;
      quantity?: number;
      fare_basis?: string;
      tag_price?: string;
      item_category2?: string;
      item_category3?: string;
    }>;
  };
}

export class MMBVpvEventParamsDto extends MMBBaseEventParamsDto {
  page_title?: string;
}

export class MMBInteractionsEventParamsDto extends MMBBaseEventParamsDto {
  evento_interactivo_categoria: string;
  evento_interactivo_accion: string;
  evento_interactivo_etiqueta: string;
}

export class MMBUserPropertiesDto {
  pas_dni_hashed: string;
  birthday?: string;
  user_type: string;
}

export class MMBEventDto {
  event: "vpv" | "interacciones";
  event_params: MMBVpvEventParamsDto | MMBInteractionsEventParamsDto;
  user_properties?: MMBUserPropertiesDto;
}

export interface BaseEventInput {
  micrositio: string;
  page_path: string;
  page_type: string;
  homemarket: string;
  environment: string;
  login: boolean;
  negocio: string;
  bundle?: string;
  buy_instance?: string;
  initial_date?: string;
  end_date?: string;
  exchange_rate?: string;
  from_iata?: string;
  to_iata?: string;
  full_trip?: string;
  full_trip_dates?: string;
  fare_basis?: string;
  count_seats?: number;
  count_bags?: number;
  count_carry_on?: number;
  passengers_adult?: number;
  passengers_child?: number;
  passengers_infant?: number;
  passengers_pet?: number;
  pax?: number;
  trip_type?: string;
  tag_price?: string;
  time?: string;
  currency?: string;
  payment_method?: string;
  pnr?: string;
  method?: string;
  ecommerce?: {
    transaction_id?: string;
    affiliation?: string;
    pnr?: string;
    payment_type?: string;
    tax?: number;
    value?: number;
    items?: Array<{
      active?: boolean;
      cabin?: string;
      date?: string;
      price?: number;
      priceWithTaxes?: number;
      index?: number;
      item_category?: string;
      item_id?: string;
      item_list_name?: string;
      item_name?: string;
      item_variant?: string;
      quantity?: number;
      fare_basis?: string;
      tag_price?: string;
      item_category2?: string;
      item_category3?: string;
    }>;
  };
  user_props?: {
    pas_dni?: string;
    birthday?: string;
    user_type?: string;
  };
}

export interface VpvEventInput extends BaseEventInput {
  page_title?: string;
  type: "vpv";
}

export interface InteractionsEventInput extends BaseEventInput {
  evento_interactivo_categoria: string;
  evento_interactivo_accion: string;
  evento_interactivo_etiqueta: string;
  type: "interacciones";
}
